import { api, TENANT_ID } from '../services/api'

const conTenant = (ruta: string) => `${ruta}?tenantId=${TENANT_ID}`

export const obtener = <T>(recurso: string) => api.get<T>(conTenant(`/${recurso}`))
export const enviar = (recurso: string, data: unknown) =>
  api.post<{ mensaje?: string } | undefined>(conTenant(`/${recurso}`), data).then((r) => r ?? { mensaje: 'Registro guardado' })
export const actualizar = (ruta: string, data: unknown) =>
  api.put<{ mensaje?: string } | undefined>(conTenant(`/${ruta}`), data).then((r) => r ?? { mensaje: 'Registro guardado' })
export const eliminar = (ruta: string) => api.del<void>(conTenant(`/${ruta}`))

export function mensajeError(error: unknown): string {
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  return 'Ocurrio un error inesperado'
}
